import { backendApi } from "../backendApi"
import {
  LoginCredentials,
  RegisterData,
  ChangePasswordData,
  ForgotPasswordData,
  ResetPasswordData,
  User,
  LoginResponseData,
  CreateUserData,
  UpdateUserData
} from "@/domain/auth/auth"
import { ApiResponse, PaginatedResponse } from "@/domain"

export const authApi = {
  login: (credentials: LoginCredentials) =>
    backendApi.post<ApiResponse<LoginResponseData>>('/api/v1/auth/login', credentials).then((res) => res.data.data),

  register: (data: RegisterData) =>
    backendApi.post<ApiResponse<LoginResponseData>>('/api/v1/auth/register', data).then((res) => res.data.data),

  logout: () =>
    backendApi.post<ApiResponse<void>>('/api/v1/auth/logout').then((res) => res.data.data),

  getProfile: () =>
    backendApi.get<ApiResponse<User>>('/api/v1/auth/profile').then((res) => res.data.data),

  changePassword: (data: ChangePasswordData) =>
    backendApi.put<ApiResponse<void>>('/api/v1/auth/password', data).then((res) => res.data.data),

  forgotPassword: (data: ForgotPasswordData) =>
    backendApi.post<ApiResponse<void>>('/api/v1/auth/forgot-password', data).then((res) => res.data.data),

  resetPassword: (data: ResetPasswordData) =>
    backendApi.post<ApiResponse<void>>('/api/v1/auth/reset-password', data).then((res) => res.data.data),
}

export const userApi = {
  getUsers: (params?: { page?: number; limit?: number; search?: string; roles?: string; status?: string }) =>
    backendApi.get<ApiResponse<PaginatedResponse<User>>>('/api/v1/auth/users', { params }).then((res) => res.data.data),

  getUser: (id: string) =>
    backendApi.get<ApiResponse<User>>(`/api/v1/auth/users/${id}`).then((res) => res.data.data),

  createUser: (data: CreateUserData) =>
    backendApi.post<ApiResponse<User>>('/api/v1/auth/users', data).then((res) => res.data.data),

  updateUser: (id: string, data: UpdateUserData) =>
    backendApi.put<ApiResponse<User>>(`/api/v1/auth/users/${id}`, data).then((res) => res.data.data),

  deleteUser: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/auth/users/${id}`).then((res) => res.data.data),

  updateUserRoles: (userId: string, roles: string[]) =>
    backendApi.put<ApiResponse<void>>(`/api/v1/auth/users/${userId}/roles`, { roles }).then((res) => res.data.data),

  updateUserStatus: (userId: string, status: string) =>
    backendApi.put<ApiResponse<void>>(`/api/v1/auth/users/${userId}/status`, { status }).then((res) => res.data.data),
}
